import * as React from "react";
const SvgHandle = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><path fill="#828282" d="M1.667 6.667h16.666V8.75H1.667zm0 4.167h16.666v2.083H1.667z" /></svg>;
export { SvgHandle as ReactComponent };